export default [
  {
    path: '',
    name: 'voucher list',
    component: () => import('@/views/app/voucher/list/page-list.vue'),
    meta: { title: 'Daftar Voucher' },
  },
  {
    path: 'baru',
    name: 'voucher create',
    component: () => import('@/views/app/voucher/create/page-create.vue'),
    meta: { title: 'Buat Voucher' },
  },
]
